var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('div',{staticClass:"grade",staticStyle:{"box-sizing":"border-box","padding":"20px"}},[_c('el-page-header',{attrs:{"content":"成绩对比"},on:{"back":_vm.goBack}}),_c('div',{staticStyle:{"width":"100%","height":"500px"},attrs:{"id":"chart-container"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }